// extracted by mini-css-extract-plugin
module.exports = {"event":"styles_event__3UlO0","event__id":"styles_event__id__1xDWz","event__title":"styles_event__title__22ic2","event__item":"styles_event__item__VddaO"};